import { ViewModel,View, ObservableArray, DelegatedObservableArrayChangeListenner } from "binder"
import { ISidebarActivationRemover } from "../sidebar-viewModel";
import  { SidebarItemView } from "./sidebarItem-view"
declare var showSidebarIcons : boolean;
export class SidebarItemViewModel extends ViewModel implements ISidebarActivationRemover{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.typedParent = <ISidebarActivationRemover><unknown>parentViewModel;
        this.isExpanded = false;
        this.isExpandable = false;
        this.showSidebarIcons = showSidebarIcons;
        this.children = ObservableArray.create<SidebarItemViewModel>();
        this.children.addChangeListenner(new DelegatedObservableArrayChangeListenner(this,x=>{
            if(x.length>0)
                this.isExpandable = true;
            else
                this.isExpandable = false;
        }))
    }
    GetDefaultView(): View <ViewModel> {
        return new SidebarItemView();
    }
    public getTypeId(): string {
        return "VM-3162E16E-6F6C-4C7D-BF76-ECB5237A43F9"
    }

    private typedParent:ISidebarActivationRemover;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set className(v: string) { this._className = v; } public get className(): string { return this._className;} private _className: string;
    public set children(v: ObservableArray<SidebarItemViewModel>) { this._children = v; } public get children(): ObservableArray<SidebarItemViewModel> { return this._children;} private _children: ObservableArray<SidebarItemViewModel>;
    public set command(v: ()=>void) { this._command = v; } public get command(): ()=>void { return this._command;} private _command: ()=>void;
    
    public set isActive(v: boolean) { this._isActive = v; } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set isExpanded(v: boolean) { this._isExpanded = v; } public get isExpanded(): boolean { return this._isExpanded;} private _isExpanded: boolean;
    public set isExpandable(v: boolean) { this._isExpandable = v; } public get isExpandable(): boolean { return this._isExpandable;} private _isExpandable: boolean;
    public set isFavorite(v: boolean) { this._isFavorite = v; } public get isFavorite(): boolean { return this._isFavorite;} private _isFavorite: boolean;
    public set favoriteChanged(v: (x:boolean)=>void) { this._favoriteChanged = v; } public get favoriteChanged(): (x:boolean)=>void { return this._favoriteChanged;} private _favoriteChanged: (x:boolean)=>void;
    public set showSidebarIcons(v: boolean) { this._showSidebarIcons = v; } public get showSidebarIcons(): boolean { return this._showSidebarIcons;} private _showSidebarIcons: boolean;
    
    toggleFavorite() {
        this.isFavorite = !this.isFavorite;
        this.favoriteChanged(this.isFavorite);
    }

    choose(){
        if(this.isExpandable){
            this.isExpanded = !this.isExpanded;
            this.isActive = this.isExpanded;
        }else{
            this.isActive = true;
            this.typedParent.onItemActivated(this);
            this.command();
        }
        
    }

    deactivate() {
        this.isActive = false;
        this.isExpanded = false;
        this.children.forEach(x=>x.deactivate());
    }
    
    onItemActivated(item: SidebarItemViewModel) {
        this.children.forEach(x=>{
            if(x!=item)
                x.deactivate();
        });
        this.typedParent.onItemActivated(this);
    }
}
